// extracted by mini-css-extract-plugin
export default {"bolosList":"BolosAluguel_bolosList__F+Tp+","bolosList__colQuadro":"BolosAluguel_bolosList__colQuadro__EMTVZ"};